import {
  Box,
  InputBaseComponentProps,
  InputLabel,
  FormHelperText,
  FormControl,
  OutlinedInput,
  OutlinedInputProps,
} from '@mui/material'
import React, { ChangeEvent, forwardRef } from 'react'
import { colors } from '../themes/colors'

interface InputProps extends OutlinedInputProps {
  label: string
  errorMessage?: string
  disableError?: boolean
  value?: string | number
  setValue?: React.Dispatch<React.SetStateAction<string | undefined>>
  helperText?: string
  helperTextColor?: string
  testId: string
  type: React.HTMLInputTypeAttribute | undefined
  required?: boolean
  inputBaseProps?: InputBaseComponentProps
  outlineInputProps?: OutlinedInputProps
  placeholder?: string
  colon?: boolean
  onChange?: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
}
const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      errorMessage,
      value,
      setValue,
      testId,
      type,
      required,
      inputBaseProps,
      outlineInputProps,
      disableError,
      placeholder,
      helperText,
      helperTextColor,
      onChange,
      colon = false,
      ...props
    },
    ref,
  ) => {
    let _label = label
    if (!colon && _label.trim().endsWith(':')) {
      _label = label.replace(':', '')
    }
    return (
      <Box flexGrow={1} width={'100%'} display='flex' flexDirection='column'>
        <Box display='flex' gap={1}>
          <InputLabel htmlFor={testId}>{_label}</InputLabel>
          <InputLabel
            sx={{
              fontWeight: '400',
              color: !errorMessage ? colors.grey700 : colors.error700,
            }}
          >
            {required ? '(Required)' : ''}
          </InputLabel>
        </Box>
        <FormControl error={!!errorMessage}>
          <OutlinedInput
            {...outlineInputProps}
            inputRef={ref}
            id={testId}
            error={!!errorMessage}
            value={value}
            onChange={(e) => {
              if (onChange) onChange(e)
              if (setValue) setValue(e.target.value)
            }}
            type={type}
            // size='small'
            placeholder={placeholder}
            inputProps={{
              'data-testid': testId,
              ...inputBaseProps,
            }}
            {...props}
          />
          {helperText && (
            <FormHelperText sx={{ color: helperTextColor }}>{helperText}</FormHelperText>
          )}

          {!disableError && (
            <FormHelperText id={`${testId}-helper-text`} data-testid={`${testId}-helper-text`}>
              {errorMessage ?? ' '}
            </FormHelperText>
          )}
        </FormControl>
      </Box>
    )
  },
)
Input.displayName = 'Input'

export default Input
